<script>
    import FusionCharts from 'fusioncharts';
    import Widgets from 'fusioncharts/fusioncharts.widgets';
    import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
    import SvelteFC, { fcRoot } from 'svelte-fusioncharts';
    import Moon from 'svelte-loading-spinners/dist/ts/Moon.svelte';

    
    export let title;
    export let data;
    export let loading = false;

    fcRoot(FusionCharts, Widgets, FusionTheme);

    let dataSource = {
        chart: {
            caption: title,
            lowerLimit: '0',
            upperLimit: '100',
            showValue: '1',
            numberSuffix: '%',
            theme: 'fusion',
            showToolTip: '0',
        },
        colorRange: {
            color: [
                {
                    minValue: '0',
                    maxValue: '50',
                    code: '#F2726F',
                },
                {
                    minValue: '50',
                    maxValue: '75',
                    code: '#FFC533',
                },
                {
                    minValue: '75',
                    maxValue: '100',
                    code: '#62B58F',
                },
            ],
        },
        dials: {
            dial: [
                {
                    value: data?.count || 0,
                },
            ],
        },
    };

    let chartConfig = {
        type: 'angulargauge',
        width: '100%',
        height: '400',
        dataSource,
    };
</script>

<div id="chart-container" class="p-4 transition-shadow border rounded-lg col-span-3 shadow-sm hover:shadow-lg bg-white">
    {#if loading}
        <div class="h-16 flex items-center justify-center">
            <Moon size={2} color="#FF3E00" unit="rem" duration="1s" />
        </div>
    {:else}
        <SvelteFC {...chartConfig} />
    {/if}
</div>

